import { css } from 'lit';

export const planeMenuStyles = css`
  :host {
    display: inline-flex;
  }

  .anchor {
    position: relative;
    display: inline-flex;
  }

  .toggle {
    justify-content: center;
    min-width: var(--control-height);
    font-size: var(--font-size-lg);
    letter-spacing: var(--tracking-wide);
  }

  :host([open]) .toggle {
    border-color: var(--text);
  }

  .panel {
    position: absolute;
    top: calc(100% + var(--space-1));
    right: 0;
    z-index: var(--z-overlay);
    display: grid;
    min-width: 12rem;
    padding: var(--space-1) 0;
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface-raised);
    box-shadow: var(--shadow-float);
  }

  .panel[hidden] {
    display: none;
  }
`;
